import configs from '@/configs';
import {request_header, request_list} from '@/commons/hpod';

export default {
    getPaymentHistoryList(cb, $http, param, token) {
        request_list('payment_histories', cb, $http, param, token)
    },
    getPaymentHistoryDetail(cb, $http, id, token) {
        const header = {
            headers: request_header(token)
        };

        $http.get(`${process.env.VUE_APP_ENDPOINT}/admin/api/payment_histories/${id}`, header).then(function (res) {
            setTimeout(() => cb(res.data), 100);
        });
    }
}
